module.exports = __webpack_public_path__ + "img/AminMusaDPS.97ef3f86.jpg";